import { render } from "./PricingReviewRequest.vue?vue&type=template&id=58511e5f&scoped=true&ts=true"
import script from "./PricingReviewRequest.vue?vue&type=script&lang=ts"
export * from "./PricingReviewRequest.vue?vue&type=script&lang=ts"

import "./PricingReviewRequest.vue?vue&type=style&index=0&id=58511e5f&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58511e5f"]])

export default __exports__